

















import { defineComponent } from '@vue/composition-api';
import StepperHeader from '@front-app/components/stepper/StepperHeader.vue';
import ProfileCardRoles from './ProfileCardRoles.vue';
import { STEP_PROPS } from './steps';

export default defineComponent({
	components: { StepperHeader, ProfileCardRoles },
	props: STEP_PROPS,
	setup() {
		return {};
	},
});
